import { IUserRegister } from 'entities';
import {
  IBranchInputModel,
  IClientDeleteInputModel,
  IClientInputModel,
  ICollaboratorInputModel,
  ICourtInputModel,
  ICreateClientInputModel,
  IDepartmentInputModel,
  IDepartmentUpdateModel,
  IProfileInputModel,
  IProfileUpdateInputModel,
  ITransferCollaboratorInputModel,
} from 'inputModels';
import {
  IBranchViewModel,
  IClientViewModel,
  ICollaboratorViewModel,
  ICompanyClientViewModel,
  ICorrespondenceViewModel,
  ICourtViewModel,
  IDepartmentViewModel,
  IProfileLimitValueViewModel,
  IProfileViewModel,
  ISolicitationViewModel,
  ISpecialtyViewModel,
} from 'viewModels';
import api from '../services/api/axios';

const updateCompany = (company: FormData) => {
  return api.put('user/update-company', company, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const getBranchesByUserId = (uid: string | undefined) => {
  return new Promise<IBranchViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-branches/${uid}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const createBranch = (branch: IBranchInputModel) => {
  return new Promise<string>((resolve, reject) => {
    api
      .post('company/new-branch', branch)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const updateBranch = (branch: IBranchViewModel) => {
  return api.put('company/update-branch', branch);
};
const deleteBranch = (id: string) => {
  return api.delete(`company/delete-branch/${id}`);
};
const getCollaboratorsByCompanyId = (uid: string | undefined) => {
  return new Promise<ICollaboratorViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-collaborators/${uid}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const getCollaboratorById = (uid: string) => {
  return new Promise<ICollaboratorViewModel>((resolve, reject) => {
    api
      .get(`company/get-collaborator-by-id/${uid}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const createCollaborator = (collaborator: ICollaboratorInputModel) => {
  return api.post('company/new-collaborator', collaborator);
};
const updateCollaborator = (Collaborator: ICollaboratorViewModel) => {
  return api.put('company/update-collaborator', Collaborator);
};
const deleteCollaborator = (id: string) => {
  return api.delete(`company/delete-collaborator/${id}`);
};
const createProfile = (profile: IProfileInputModel) => {
  return api.post('company/new-profile', profile);
};
const getProfilesByUserId = (uid: string | undefined) => {
  return new Promise<IProfileViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-profiles/${uid}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const getProfileById = (id: string | undefined) => {
  return new Promise<IProfileViewModel>((resolve, reject) => {
    api
      .get(`company/get-profile/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const getCollaboratorsByProfileId = (id: string | undefined) => {
  return new Promise<ICollaboratorViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-collaborators-profile/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const updateProfile = (profile: IProfileUpdateInputModel) => {
  return api.put('company/update-profile', profile);
};

const deleteProfile = (to: string | undefined, id: string | undefined) => {
  return api.delete(`company/delete-profile/`, {
    params: { id, to },
  });
};

const findCompanyById = (id: string) => {
  return new Promise<IUserRegister>((resolve, reject) => {
    api
      .get(`user/find-company-by/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const addDepartment = (input: IDepartmentInputModel) => {
  return new Promise<string>((resolve, reject) => {
    api
      .post('company/new-department', input, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const getAllDepartments = (uid: string) => {
  return new Promise<IDepartmentViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-all-departments/${uid}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const getAllProfileLimitValue = (companyId: string, maxValue: number) => {
  return new Promise<IProfileLimitValueViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-profiles-limit-value/`, {
        params: { companyId, maxValue },
      })
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const updateDepartment = (update: IDepartmentUpdateModel) => {
  return api.put('company/update-department', update);
};

const transferCollaborators = (update: ITransferCollaboratorInputModel) => {
  return api.put('company/transfer-collaborators', update);
};

const addClient = async (input: IClientInputModel) =>
  new Promise<string>((resolve, reject) => {
    api
      .post(`company/add-client`, input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const deleteClient = async (client: IClientDeleteInputModel) => {
  return new Promise<string>((resolve, reject) => {
    api
      .delete(`company/delete-client`, { data: client })
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const getClientByUserId = (uid: string) => {
  return new Promise<IClientViewModel[]>((resolve, reject) => {
    api
      .get(`company/${uid}/get-clients`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(reject);
  });
};

const getClientById = (id: string) => {
  return new Promise<IClientViewModel>((resolve, reject) => {
    api
      .get(`company/get-client-by/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const getClientsByProfileId = (id: string) => {
  return new Promise<IClientViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-clients-by-profile/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const getSpecialtiesByProfileId = (id: string) => {
  return new Promise<ISpecialtyViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-specialties-by-profile/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const getCorrespondencesByProfileId = (id: string) => {
  return new Promise<ICorrespondenceViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-correspondences-by-profile/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const getCourtsByDistrictSelected = (uuid: string) => {
  return new Promise<ICourtViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-courts-by-district/${uuid}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const addCourt = async (input: ICourtInputModel) =>
  new Promise<string>((resolve, reject) => {
    api
      .post(`company/add-court`, input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const deleteCourt = async (id: string) => {
  return new Promise<string>((resolve, reject) => {
    api
      .delete(`company/delete-court/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const createClient = async (input: ICreateClientInputModel) => {
  return new Promise<ICompanyClientViewModel>((resolve, reject) => {
    api
      .post(`company/create-client`, input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const getClients = async () => {
  return new Promise<ICompanyClientViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-all-client`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const deleteClients = async (id: string) => {
  return new Promise<ICompanyClientViewModel[]>((resolve, reject) => {
    api
      .delete(`company/delete-client/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const getSolicitationsByClientId = async (clientId: string) =>{
  return new Promise<ISolicitationViewModel[]>((resolve, reject) => {
    api
      .get(`company/get-solicitations-by-client/${clientId}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
}

export const CompanyController = {
  update: updateCompany,
  getBranchesByUserId,
  createBranch,
  updateBranch,
  deleteBranch,
  getCollaboratorsByCompanyId,
  createCollaborator,
  updateCollaborator,
  deleteCollaborator,
  getCollaboratorsByProfileId,
  getCollaboratorById,
  createProfile,
  getProfilesByUserId,
  getProfileById,
  updateProfile,
  deleteProfile,
  findCompanyById,
  addDepartment,
  getAllDepartments,
  updateDepartment,
  transferCollaborators,
  getAllProfileLimitValue,
  addClient,
  deleteClient,
  getClientByUserId,
  getClientById,
  getClientsByProfileId,
  addCourt,
  deleteCourt,
  getCourtsByDistrictSelected,
  getSpecialtiesByProfileId,
  getCorrespondencesByProfileId,
  createClient,
  getClients,
  deleteClients,
  getSolicitationsByClientId
};
